import { apiRequest } from './client';

/** Newsletter administration (SRS #29). */

const TOKEN_KEY = 'policyora_token';
const opts = (extra: RequestInit = {}): RequestInit => {
  const token = localStorage.getItem(TOKEN_KEY);
  return { ...extra, headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(extra.headers || {}) } };
};

export interface NewsletterSettings {
  disabled_sources: string[];
  blocked_keywords: string[];
  max_items: number;
  send_hour_utc: number;
  intro_note: string;
  frequencies_enabled: ('daily' | 'weekly' | 'monthly')[];
}
export interface NewsletterSourceStat {
  source_key: string; name: string; country: string; url?: string | null;
  enabled: boolean; articles: number; last_seen: string | null;
}
export interface NewsletterAdminView {
  settings: NewsletterSettings;
  defaults: NewsletterSettings;
  sources: NewsletterSourceStat[];
  topics: { key: string; label: string }[];
  stats: { subscribers: { daily: number; weekly: number; monthly: number }; unsubscribed: number; sent_today: number; sent_last_7_days: number };
}
export interface NewsletterPreviewItem { title: string; url: string; source_name: string; country: string; topics: string[]; score: number }

export const getNewsletterAdmin = (days = 30) => apiRequest<NewsletterAdminView>(`/api/v1/admin/newsletter/settings?days=${days}`, opts());
export const updateNewsletterSettings = (patch: Partial<NewsletterSettings>) =>
  apiRequest<{ settings: NewsletterSettings }>('/api/v1/admin/newsletter/settings', opts({ method: 'PUT', body: JSON.stringify(patch) }));
export const setNewsletterSource = (sourceKey: string, enabled: boolean) =>
  apiRequest<{ source_key: string; enabled: boolean; disabled_sources: string[] }>(`/api/v1/admin/newsletter/sources/${encodeURIComponent(sourceKey)}`, opts({ method: 'PATCH', body: JSON.stringify({ enabled }) }));
export const sendNewslettersNow = () => apiRequest<{ sent: number; skipped: number; errors: number }>('/api/v1/admin/newsletter/send-now', opts({ method: 'POST' }));
export const previewNewsletter = (picks: { countries?: string[]; topics?: string[]; sources?: string[]; industries?: string[]; frequency?: string }) =>
  apiRequest<{ pool: number; items: NewsletterPreviewItem[] }>('/api/v1/admin/newsletter/preview', opts({ method: 'POST', body: JSON.stringify(picks) }));
